import React, { useState, useRef, useEffect } from "react";

const PasswordInfoTooltip = ({
  children,
  tooltipText,
  defaultPosition = "top",
}) => {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState(defaultPosition);
  const tooltipRef = useRef();
  const wrapperRef = useRef();

  const toggleTooltip = () => {
    setVisible((prev) => !prev);
  };

  // Close tooltip when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Detect position based on space
  useEffect(() => {
    if (visible && tooltipRef.current && wrapperRef.current) {
      const tooltipRect = tooltipRef.current.getBoundingClientRect();
      const triggerRect = wrapperRef.current.getBoundingClientRect();

      const spaceAbove = triggerRect.top;
      const spaceBelow = window.innerHeight - triggerRect.bottom;

      if (
        spaceAbove < tooltipRect.height + 10 &&
        spaceBelow > tooltipRect.height + 10
      ) {
        setPosition("bottom");
      } else {
        setPosition("top");
      }
    }
  }, [visible]);

  return (
    <div className="tooltip-container" ref={wrapperRef}>
      <div className="text-end" onClick={toggleTooltip}>
        {children}
      </div>
      {visible && (
        <div className={`tooltip-box ${position}`} ref={tooltipRef}>
          {tooltipText}
          <span className="tooltip-arrow" />
        </div>
      )}
    </div>
  );
};

export default PasswordInfoTooltip;
